import { render, staticRenderFns } from "./SingleOnboard.vue?vue&type=template&id=08fac1f7&scoped=true"
import script from "./SingleOnboard.vue?vue&type=script&lang=js"
export * from "./SingleOnboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08fac1f7",
  null
  
)

export default component.exports